import { queries as mq, updateHash, toggleVideoPlayBack } from '../utils/Utils';

export const MenuController = () => {

  createOverlay();
  toggleMenu();

  calculateHeight();

  $(window).on("window:resize", (e) => {
    calculateHeight();
  })

  // mobileStickyHeader();
}


const createOverlay = () => {
  if($('.menu-overlay').length === 0) {
    $('body').append('<div class="menu-overlay"></div>');
    if(!$('body').hasClass('show-menu')) {
      $('.menu-overlay').hide();
    }
  }

  $('.menu-overlay').bind('click', (e) => {
    $('body').removeClass('show-menu');

    setTimeout(function(){
      $('.menu-overlay').hide();
      window.allowScroll = true;
    }, 500);
  });
}


const toggleMenu = () => {
  $('.toggle-menu').click((e) => {

    if($('body').hasClass('show-menu')) {
      window.allowScroll = true;
      setTimeout(function(){
        $('.menu-overlay').hide();
      }, 500);
    } else {
      window.allowScroll = false;
      $('.menu-overlay').show();
    }

    setTimeout(function(){
      $('body').toggleClass('show-menu');
    }, 10);
  });
}


const calculateHeight = () => {
  const $nav = $('.main-nav');
  const navHeight = $nav.outerHeight();
  const menuHeight = $('.offscreen-menu').height();
  //console.log({'navHeight': menuHeight, 'docHeight': menuHeight});

  if(navHeight > menuHeight) {
    $('.offscreen-menu__main').css({'display': 'block'})
  } else {
    $('.offscreen-menu__main').css({'display': ''})
  }

}


const mobileStickyHeader = () => {
  enquire.register(mq.mobile, {
    match: () => {

      $(window).on('DOMMouseScroll mousewheel', function (e, delta) {

        let scrollTop = $(window).scrollTop();
        let scrollDir = 'down';
        let headerHeight = $('.header__inner').height();
        // console.log({'delta': delta, 'scrollTop': scrollTop})

        if(delta <= 0) {
          scrollDir = 'up';
        }

        if(scrollDir == 'down' || scrollTop <= ($(window).height() / 4) || $('body').hasClass('show-menu')) {
          $('.toggle-menu, .header').css({
            transform: 'translateY(0)'
          });
        } else {
          $('.toggle-menu, .header').css({
            transform: 'translateY(-' + headerHeight + 'px)'
          });

          $('.header').css({
            backgroundColor: 'rgba(0,0,0,0.2)'
          });
        }
      });
    },
    unmatch: () => {
      $('.toggle-menu, .header').css({
        backgroundColor: '',
        transform: ''
      });

      $(window).off('DOMMouseScroll mousewheel');
    },
  })
}



// WEBPACK FOOTER //
// ./src/js/controllers/MenuController.js